import Cookies from "js-cookie";
import { BurdeUser, CalendarState } from "burde";
import { COOKIE_USER_JWT } from "ui/constants";
import * as api from "util/api";

export const refreshJwtToken = async (jwt: string): Promise<string | null> => {
    try {
        const { success, data } = await api.json.get(
            `api/burdeUser/refreshJwt?jwt=${jwt}`,
        );

        if (!success) {
            return null;
        }

        return data;
    } catch {
        return null; // TODO: Fix this.
    }
};

export const getUserDesigns = async (): Promise<CalendarState[] | null> => {
    try {
        const jwt = Cookies.get(COOKIE_USER_JWT);

        if (!jwt) return null; // TODO: Handle better.

        const { success, data } = await api.json.get(
            `api/burdeUser/getBurdeUserDesigns?jwt=${jwt}`,
        );

        if (!success) {
            return null;
        }

        return data;
    } catch {
        return null; // TODO: Fix this.
    }
};

export const createUser = async (email: string, password: string) => {
    try {
        const { success, data } = await api.json.post(
            `api/burdeUser/createBurdeUser`,
            {
                email,
                password,
            },
        );

        if (!success) {
            return null;
        }

        return data;
    } catch {
        return null; // TODO: Fix this.
    }
};

export const getUser = async (): Promise<BurdeUser | null> => {
    try {
        const jwt = Cookies.get(COOKIE_USER_JWT);

        if (!jwt) return null; // TODO: Handle better.

        const { success, data } = await api.json.get(
            `api/burdeUser/getBurdeUser?jwt=${jwt}`,
        );

        if (!success) {
            return null;
        }

        return data;
    } catch {
        return null; // TODO: Fix this.
    }
};
